var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_check",
    transform: "translate(-438 -2156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M1320,7985h-14a2,2,0,0,1-2-2v-10a2,2,0,0,1,4,0v8h12a2,2,0,1,1,0,4Z",
    transform: "translate(-6115.265 -2544.16) rotate(-45)",
    fill: "#ca4539"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 32,
    height: 32,
    transform: "translate(438 2156)",
    fill: "#fff",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon_check.bda9f5491696d5925753f7e1ba68ea74.svg";
export { ForwardRef as ReactComponent };